import type { Fraction } from './fractionType';
export const initializationSegmentIndex = 0;

/*
  In segment time units, the first media segment is 0, while in segment indexes
  the first media segment is 1, since 0 is reserved for the initialization
  segment.
*/
export function getSegmentIndexFromSegmentTime(segmentTime: number, hasInitSegment: boolean) {
  return segmentTime + (hasInitSegment ? 1 : 0);
}

export function getSegmentIndexFromMediaTime(time: number, segmentDuration: Fraction, hasInitSegment: boolean) {
  const segmentTime = Math.floor(time * segmentDuration.denominator / segmentDuration.numerator);
  return getSegmentIndexFromSegmentTime(segmentTime, hasInitSegment);
}
